import styled from 'styled-components';

interface PlayButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
}
export default function PlayButton({ onClick, children }: PlayButtonProps) {
  return (
    <PlayButtonContainer aria-label="login as learner" onClick={onClick}>
      {children ?? 'Play'}
    </PlayButtonContainer>
  );
}

const PlayButtonContainer = styled.button`
  filter: drop-shadow(4px 5px 0px #000c7b);
  background: #219b39;
  font-family: 'BioRhyme';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 10px;
  /* identical to box height */
  text-align: center;
  color: #ffffff;
  border: 2px solid #ffffff;
  padding: 12px 12px;
  width: 5rem;
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
`;
